import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin({
  // Run before Nuxt Router (-20) and block its temporary automatic restoration.
  order: -21,
  setup(nuxtApp) {
    if (!('scrollRestoration' in window.history)) return

    window.history.scrollRestoration = 'manual'
    Object.defineProperty(window.history, 'scrollRestoration', {
      configurable: true,
      get: () => 'manual',
      set: () => undefined,
    })

    nuxtApp.hook('app:created', () => {
      Reflect.deleteProperty(window.history, 'scrollRestoration')
      window.scrollTo(0, 0)
    })
  },
})
